export default "__VITE_ASSET__DElrq7k7__"